<script>
    export default {
        props: ['cartelementsprop', 'sportmenprop', 'totalpriceprop'],
        data() {
            return {
                modalShow: [],
                cartElements: [],
                total: 0,
                exploitable_code: null,
                exploitable_message: '',
                exploitable: {
                    fixed_discount: null,
                    percent_discount: null,
                },
                exploitable_used: false
            }
        },
        computed: {
            giftCards() {
                return this.cartElements.filter(i => i.buyable_type == 'App\\CustomGiftCard')
            },
            defaultItems() {
                return this.cartElements.filter(i => {
                    return i.buyable_type != 'App\\CustomGiftCard'
                })
            }
        },
        mounted() {
            var self = this;

            this.cartElements = this.cartelementsprop;
            this.total = this.totalpriceprop;

            this.cartElements.forEach(function (cartElement) {
                var index = self.cartElements.indexOf(cartElement);
                self.modalShow[index] = false;
            })
        },
        watch: {
            total: function (newData, oldData) {
                // console.log('test');
                this.$bus.$emit('total-updated', newData);
            },
        },
        methods: {
            getCourseThumbImage(element) {
                if (element.buyable.course.course_thumb_image)
                    return element.buyable.course.course_thumb_image
                return element.buyable.course.sport.course_cover_image;
            },
            checkValidation() {
                var self = this;

                if (this.exploitable_used) {
                    bootbox.alert("<legend class='text-center m-b-20'>Coupon / Voucher già inserito</legend>")
                    return;
                }

                axios({
                    method: 'post',
                    url: '/exploitables/',
                    data: {
                        code: this.exploitable_code,
                        total: this.total,
                    }
                }).then((response) => {
                    self.exploitable_message = response.data.exploitable_message;
                    self.exploitable = response.data.exploitable;
                    self.exploitable_used = true;

                    $('.exploitable_input').removeClass('border-danger');
                    $('.exploitable_message').removeClass('text-danger');
                    $('.exploitable_input').addClass('border-success');
                    $('.exploitable_message').addClass('text-success');
                    $('.exploitable_input').attr('disabled', true);
                    /*$('.payment-tabs__cart__content__item__details__discount').removeClass('hidden');*/
                    $('.exploitable_hidden_input').val(self.exploitable.code);

                    self.applyDiscount();

                    bootbox.alert(self.generateHtml())

                }).catch((error) => {
                    self.exploitable_message = error.response.data.exploitable_message;
                    $('.exploitable_input').addClass('border-danger');
                    $('.exploitable_message').addClass('text-danger');
                });
            },
            applyDiscount() {
                if (this.exploitable.fixed_discount) {
                    this.total -= this.exploitable.fixed_discount;
                    this.$bus.$emit('discount-applied', this.exploitable.fixed_discount);
                } else if (this.exploitable.percent_discount) {
                    this.total -= (this.total * this.exploitable.percent_discount) / 100
                    this.$bus.$emit('discount-applied', (this.total * this.exploitable.percent_discount) / 100);
                } else if (this.exploitable.price) {
                    this.total -= this.exploitable.price;
                    this.$bus.$emit('discount-applied', this.exploitable.price);
                }
                this.total = this.total.toFixed(2)
            },
            generateHtml() {
                if (this.exploitable.fixed_discount) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.fixed_discount + "€" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.total > 0 ? this.total : 0 + "€") +
                        "</strong>" +
                        "</p>"
                } else if (this.exploitable.percent_discoucount) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.percent_discount + "%" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.total > 0 ? this.total : 0 + "€") +
                        "</strong>" +
                        "</p>"
                } else if (this.exploitable.price) {
                    return "<legend class='text-center m-b-20'>" +
                        this.exploitable_message +
                        "</legend>" +
                        "<p>Sconto applicato: " +
                        "<strong>" +
                        this.exploitable.price + "€" +
                        "</strong>" +
                        "</p>" +
                        "<p>Totale scontato: " +
                        "<strong>" +
                        (this.total > 0 ? this.total : 0 + "€") +
                        "</strong>" +
                        "</p>" +
                        (this.total < 0 ? '<small class="text-danger">' +
                            'Il costo del tuo voucher è superiore a quello dell\' acquisto di ' +
                            this.total * -1 + '€. </small>' +
                            '<small class="text-danger">' +
                            'Al termine dell\'acquisto sarà generato un nuovo voucher del valore sopra indicato.</small>' : '')
                }
            },
            tabNumber(id) {
                return id
            },
            isSubscription(buyable_type) {
                return buyable_type === "App\\CourseSubscription"
            },
            isLessonPackage(buyable_type) {
                return buyable_type === "App\\LessonPackage"
            },
            isPromotion(buyable_type) {
                return buyable_type === "App\\CoursePromotion"
            },
            getPromoDescription(element) {
                let textType = element.buyable.lesson_type == 'group' ? 'di gruppo' : 'individuali'
                return `${element.buyable.lessons} lezioni ${textType} per ${element.buyable.people} persone`
            },
            goAhead(to) {
                this.$bus.$emit('go-ahead', to);
            },
            /*showDeleteModal(cartElementId) {
                $("#cart-element" + cartElementId).modal();
            },
            hideDeleteModal(cartElementId) {
                $("#cart-element" + cartElementId).modal('hide');
            },*/
            getCartElementId(cartElementId) {
                return 'cart-element' + cartElementId;
            },
            getMembershipFeeId(cart_element_id) {
                return 'cart_element_' + cart_element_id
            },
            switchMembershipFee(cart_element) {
                var self = this;

                if (cart_element.with_membership_fee) {
                    bootbox.confirm({
                        title: "<div class='text-center'><p>Sei sicuro di essere associato?</p></div>",
                        message: "<p class='text-center'>Dichiaro di essere associato/tesserato e di non dover rinnovare la quota associativa o di tesseramento</p>",
                        closeButton: false,
                        buttons: {
                            confirm: {
                                label: 'Sono associato',
                                className: "text-center btn-primary text-uppercase",
                            },
                            cancel: {
                                className: "hidden",
                            }
                        },
                        callback: function (result) {
                            let $button = $(this).find('button.btn-primary')
                            let $closeButton = $(this).find('button.close')

                            $button.prop('disabled', true)
                            $closeButton.prop('disabled', true)

                            if (result) {
                                self
                                    .setPromotionFeeActive(cart_element, 0)
                                    .then(response => {
                                        $button.prop('disabled', false)
                                        $closeButton.prop('disabled', false)

                                        bootbox.hideAll()
                                    }).catch(error => {
                                        $button.prop('disabled', false)
                                        $closeButton.prop('disabled', false)
                                    })
                            } else {
                                self.loadingQuota = false
                                bootbox.hideAll()
                            }

                            return false
                        }
                    });
                } else {
                    this.setPromotionFeeActive(cart_element, 1);
                }
            },
            setPromotionFeeActive(cart_element, active) {
                let self = this;
                return new Promise((resolve, reject) => {
                    axios({
                        method: 'post',
                        url: '/carts/switchMembershipFee',
                        data: {
                            cartElement: cart_element
                        }
                    }).then((response) => {
                        cart_element.with_membership_fee = active;
                        self.calculateTotalCart();

                        resolve()
                    }).catch((error) => {
                        self.$emit('init-error', 'Switch fallito');

                        reject('Switch fallito')
                    });
                })
            },
            calculateTotalCart() {
                let self = this;
                self.total = 0;
                self.cartElements.forEach(function (cartElement) {
                    self.total += parseInt(cartElement.buyable.price);
                    if (self.isPromotion(cartElement.buyable_type)) {
                        if (cartElement.with_membership_fee && cartElement.buyable.course.active_promotion_fee && cartElement.buyable.course.promo_membership_fee) {
                            self.total += parseInt(cartElement.buyable.course.promo_membership_fee)
                        }
                    } else if (cartElement.with_membership_fee && cartElement.buyable.membership_fee) {
                        self.total += +parseInt(cartElement.buyable.course.membership_fee)
                    }
                });
                if (self.total)
                    self.applyDiscount();
            },
            remove(elementId, elementType, index) {
                let self = this;

                bootbox.confirm({
                    message: "Sei sicuro di voler eliminare questo elemento dal carrello?.",
                    buttons: {
                        cancel: {
                            label: 'No'
                        },
                        confirm: {
                            label: 'Ok',
                            className: 'btn-primary'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            axios({
                                method: 'delete',
                                url: '/carts/' + elementId
                            }).then((response) => {
                                self.$bus.$emit('cart-element-removed', elementId);

                                self.cartElements.splice(index, 1);

                                self.calculateTotalCart();

                            }).catch((error) => {
                                self.$emit('init-error', 'Delete failed');
                            });
                        }
                    }
                });
            },
            hasExploitable() {
                if (this.exploitable) {
                    return true;
                } else {
                    return false;
                }
            },
            hasFixedDiscount() {
                if (this.exploitable) {
                    if (this.exploitable.fixed_discount) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            hasPercentDiscount() {
                if (this.exploitable) {
                    if (this.exploitable.percent_discount) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/Cart.vue